import { TableBody, TableCell, TableRow } from '@material-ui/core'
import SelectAGButton from '../SelectAgButton'
import VisioConference from '../VisioConference'
import ButtonAction from '../ButtonAction'
import moment from 'moment'

export const ExtAgsTableBody = ({
  data,
  setOpenDetail,
  openDetail,
  coproprietaire_id,
  copro_id,
  setFile,
}) => {
  return (
    <TableBody>
      {data.map((row) => (
        <TableRow
          key={row.code}
          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
          <TableCell component="th" scope="row">
            {row.code}
          </TableCell>
          <TableCell>
            {row?.dateprevisionnelle
              ? moment(row.dateprevisionnelle).format('DD/MM/YYYY')
              : 'date non disponible'}
          </TableCell>
          <TableCell>
            <ButtonAction
              setFile={setFile}
              record={row}
              source={'convocation'}
            />
          </TableCell>
          <TableCell>
            <VisioConference record={row} />
          </TableCell>
          <TableCell>
            <ButtonAction setFile={setFile} record={row} source={'pv_ag'} />
          </TableCell>
          <TableCell>
            <SelectAGButton
              setOpenDetail={setOpenDetail}
              openDetail={openDetail}
              coproprietaire_id={coproprietaire_id}
              copro_id={copro_id}
              record={row}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
